import React from 'react'; 
import { AlertListener } from './AlertConstants';

const AlertContext = React.createContext(null);

class AlertUtil{

    //Used for removing the alert from the screen
    createUUID() {
        const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
        return pattern.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : ((r & 0x3) | 0x8);
            return v.toString(16);
        });
    };

    createAlert(type, message) {
        const newAlert = {
            id: this.createUUID(),
            type: type,
            message: message,
            timeOut: 7500
        };

        // EventEmitter.emit(AlertListener.Listener, newAlert);
    }
}
const AlertTypes = {
    Success: 'success',
    Error: 'error',
    Info: 'info',
    Warning: 'warning'
}

const CreateAlert = (type, message) => {
    let util = new AlertUtil();
    util.createAlert(type, message);
}

export { CreateAlert, AlertUtil, AlertTypes, AlertContext};
